import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { BookingUrl } from '../../../shared/urls/booking.url';
import { UserUrl } from '../../../shared/urls/user.url';

@Injectable()

export class ListMemberService {
    constructor(public baseService: BaseService) { }

    searchMember(keyword, pageInfo) {
        const url = BookingUrl.SEARCH_MEMBER;
        return this.baseService.getData(url, {
            keyword: keyword, pageSize: pageInfo.size, currentPage: pageInfo.pageNumber === 0 ? 1 : pageInfo.pageNumber + 1
        });
    }

    addNewMembers(param) {
        const url = BookingUrl.ADD_NEW_MEMBERS;
        return this.baseService.postData(url, param);
    }
    getNewMemberCache() {
        const url = BookingUrl.GET_NEW_MEMBERS;
        return this.baseService.getData(url);
    }
    importFileMember(param) {
        const url = BookingUrl.IMPORT_FILE_MEMBER;
        return this.baseService.upload(url, param);
    }
    downloadFileTemplate() {
        const url = BookingUrl.DOWNLOAD_FILE_TEMPLATE;
        return this.baseService.getAll(url);
    }
    getBookingCache() {
        const url = BookingUrl.GET_BOOKING_CACHE;
        return this.baseService.getData(url);
    }
    addBooking(param) {
        const url = BookingUrl.ADD_BOOKING;
        return this.baseService.postData(url, param);
    }
    addBookingCache(param) {
        const url = BookingUrl.ADD_BOOKING_CACHE;
        return this.baseService.postData(url, param);
    }

}

export const dataRow = [
    {
        id: '1',
        name: 'Hung Vuong',
        dateOfBirth: '2017-09-10T17:00:00',
        countryOfBirth: 'Viet Nam',
        address: '10/5 D2 street HCMC',
        mobilePhone: '123456789',
        country: 'Viet Nam',
        email: 'abc@mail.com',
        occupation: 'Employee'
    },
    {
        id: '2',
        name: 'Hung Vuong',
        dateOfBirth: '2017-09-10T17:00:00',
        countryOfBirth: 'Viet Nam',
        address: '10/5 D2 street HCMC',
        mobilePhone: '123456789',
        country: 'Viet Nam',
        email: 'abc@mail.com',
        occupation: 'Employee'
    },
    {
        id: '3',
        name: 'Hung Vuong',
        dateOfBirth: '2017-09-10T17:00:00',
        countryOfBirth: 'Viet Nam',
        address: '10/5 D2 street HCMC',
        mobilePhone: '123456789',
        country: 'Viet Nam',
        email: 'abc@mail.com',
        occupation: 'Employee'
    },
];

export const dataTMBStaff = [
    {
        id: '1',
        staffName: 'Graham Fly',
        role: 'Doctor',
    }
]





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/list-member/list-member.service.ts